<template>
  <div class="share-button-container">
    <!-- Share Button -->
    <button
      type="button"
      class="btn-secondary w-full flex items-center justify-center gap-2"
      :disabled="loading || !claimUrl"
      @click="openModal"
    >
      <Share2 :size="18" />
      {{ $t('common.share', 'Share Gift Box') }}
    </button>

    <!-- Share Options Modal -->
    <ShareOptionsModal
      :open="modalOpen"
      :claim-url="claimUrl"
      :emoji-pin="emojiPin"
      :wallet-address="walletAddress"
      @close="closeModal"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { Share2 } from 'lucide-vue-next'
import ShareOptionsModal from '../ui/ShareOptionsModal.vue'

const { t: $t } = useI18n()

const props = defineProps({
  claimUrl: {
    type: String,
    required: true
  },
  emojiPin: {
    type: String,
    required: true
  },
  walletAddress: {
    type: String,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const modalOpen = ref(false)

function openModal() {
  if (props.loading || !props.claimUrl) return
  modalOpen.value = true
}

function closeModal() {
  modalOpen.value = false
}
</script>

<style scoped>
.share-button-container {
  @apply w-full;
}
</style>
